
<div class="cmp-third-party-info">
  <!-- eslint-disable-next-line vue/no-v-html -->
  <p v-html="xss($t('third_party.dialog.info'))"></p>
  <ul>
    <!-- eslint-disable vue/no-v-html -->
    <li
      v-for="label in selectedLinks"
      :key="label"
      v-html="xss($t(`third_party.dialog.terms.${label}`))"
    ></li>
    <!-- eslint-enable vue/no-v-html -->
  </ul>
</div>
